export default __webpack_public_path__ + "static/media/958.e17b9d06.gif";